import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-image-detail',
  templateUrl: 'image-detail.component.html',
  styleUrls: ['./image-detail.page.scss']
})
export class ImageDetailComponent implements OnInit {
  imageUrl: string;

  constructor(
    public modalCtrl: ModalController
  ) {
  }

  ngOnInit() {

  }

  closeModal(){
    this.modalCtrl.dismiss();
  }
}